import React, { useEffect, useRef, useState } from "react";
import bag from "../../Assets/Images/Configuration/bag.svg";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import {
    errorToastMessage,
    successToastMessage,
} from "../../utils/toastMessage";
import { commonService } from "../../utils/commonService";
import { apiResponse } from "../../utils/apiResponse";
import { setAllDates } from "../../utils/slices/headerPropertySlice";
import reload from "../../Assets/Images/Revenue-management/reloadIcon.svg";
import moment from "moment";

function AsideRateDistribution() {
    const userDetail = commonService.getLoginUserData();
    const dispatch = useDispatch();
    const [asOfDate, setAsOfDate] = useState(null);

    const [activeRoute, setActiveRoute] = useState("/");

    const [propertyStatusList, setPropertyStatusList] = useState(null);
    const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(null)

    const propertyDetail = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const allLastDates = useSelector((store) => store.headerProperty.allDates);


    const getAsOfDate = async () => {

        let asOfDateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        if (asOfDateResponse?.status_code === 0) {
            return errorToastMessage(asOfDateResponse?.message);
        } else if (asOfDateResponse?.status_code === 1) {
            setAsOfDate(
                asOfDateResponse?.data?.[0]?.last_data_refresh
                    ? asOfDateResponse?.data?.[0]?.last_data_refresh
                    : `${commonService.getDateForNode(new Date())} 00:00:00`
            );
        } else if (asOfDateResponse?.message === "Request failed with status code 403") {
            commonService.LogOutToUser()
        }
    };

    const getLastDateForAll = async () => {
        let lastDateResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.AS_OF_DATE.ALL_LAST_REFRESH_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        let response = apiResponse(false, lastDateResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let reservationDate = "",
                BiDate = "",
                rateshopDate = "",
                occDate = "";

            dataFromApi?.forEach((item) => {
                if (item?.processType === "CREATE_WIDGET") {
                    let utcDate = moment.utc(item?.updatedAt);
                    BiDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_RES") {
                    let utcDate = moment.utc(item?.updatedAt);
                    reservationDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_OCC") {
                    let utcDate = moment.utc(item?.updatedAt);
                    occDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.jobType === "RATE_SHOP") {
                    let utcDate = moment.utc(item?.updatedAt);
                    rateshopDate = moment(utcDate).local().format("L hh:mm A");
                }
            });

            dispatch(
                setAllDates({
                    BiDate,
                    reservationDate,
                    rateshopDate,
                    occDate,
                })
            );
        }

        if (!response?.isValidate) {
        }
    };

    const handlePropertyStatus = (list) => {
        if (propertyDetail?.propertycode) {
            let filterData = list?.filter(
                (x) => x?.propertyCode === propertyDetail?.propertycode
            );
            setSelectedPropertyStatus(filterData);
        }
    };

    const getPropertyStatus = async () => {
        let propertyStatusResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CRM_SNAPSHOT.GET_PROPERTY_STATUS,
                body: {
                    clientid: userDetail?.clientid ? userDetail?.clientid : "",
                },
            },
            false
        );

        let response = apiResponse(false, propertyStatusResponse);

        if (response?.isValidate) {
            handlePropertyStatus(response?.data?.data);
            setPropertyStatusList(response?.data?.data);
        }

        if (!response?.isValidate) {
            setPropertyStatusList(null);
            setSelectedPropertyStatus(null);
        }
    };

    useEffect(() => {
        if (propertyDetail) {
            getPropertyStatus()
            getAsOfDate();
            getLastDateForAll();
        }
        // }
    }, [propertyDetail]);


    const StaticMenuIcon = {
        RateDistribution: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>`,
        RoomsRatePlan: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 20h20"/><path d="M5 20V9l7-5 7 5v11"/><path d="M9 20v-5h6v5"/></svg>`,
        History: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`,
        ChannelManager: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4"/><path d="M12 18v4"/><path d="m4.93 4.93 2.83 2.83"/><path d="m16.24 16.24 2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="m4.93 19.07 2.83-2.83"/><path d="m16.24 7.76 2.83-2.83"/></svg>`
    };


    return (
        <aside className="revenue-management-aside-main asideConfigurationMain container-menu-bar">
            <ul className="list-unstyled p-0 m-0">
                <li title="Rate Distribution">
                    <NavLink to="/ratedistribution/rate-distribution" className="revenue-aside-links">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: StaticMenuIcon["RateDistribution"],
                            }}
                        ></div>
                        <span className="main-menu-text">Rate Distribution</span>
                    </NavLink>
                </li>
                <li title="Rooms & Rate Plan">
                    <NavLink to="/ratedistribution/rooms-rate-plan" className="revenue-aside-links">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: StaticMenuIcon["RoomsRatePlan"],
                            }}
                        ></div>
                        <span className="main-menu-text">Rooms & Rate Plan</span>
                    </NavLink>
                </li>
                <li title="History">
                    <NavLink to="/ratedistribution/history" className="revenue-aside-links">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: StaticMenuIcon["History"],
                            }}
                        ></div>
                        <span className="main-menu-text">History</span>
                    </NavLink>
                </li>
                <li title="Channel Manager">
                    <NavLink to="/ratedistribution/channel-manager" className="revenue-aside-links">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: StaticMenuIcon["ChannelManager"],
                            }}
                        ></div>
                        <span className="main-menu-text">Channel Manager</span>
                    </NavLink>
                </li>
            </ul>
        </aside>
    );
}

export default AsideRateDistribution;
